import type { BrowserOptions } from '@sentry/react';

type IgnoreSpanFilter = Exclude<NonNullable<BrowserOptions['ignoreSpans']>[number], string | RegExp>;

export const ignoredErrors: NonNullable<BrowserOptions['ignoreErrors']> = [
  'Invalid LatLng object: (NaN, NaN)',
  'Request aborted',
  'timeout of 60000ms exceeded',
  'Network Error',
  'CanceledError: canceled',
  // Axios HTTP status error: 401–404, 500–504
  /^Request failed with status code (40[1-4]|50[0-4])$/,
  // Custom PlutoClientException errors
  /^PlutoClientException\b/,
];

export const ignoredSpanFilters = {
  osmTiles: {
    op: /^resource\.img$/,
    name: /^\/osm\/\d+\/\d+\/\d+\.png(?:[?#].*)?$/,
  },
} as const satisfies Record<string, IgnoreSpanFilter>;
